import { CapabilityImpl } from "../data/CapabilityImpl";
import { ICapabilityRepository } from "../domain/repositories/ICapabilityRepository";
import { CapabilityUseCase } from "../domain/useCases/CapabilityUseCase";
import { CapabilityViewModel } from "../presentation/viewModel/CapabilityViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class CapabilityInjection extends InjectionModule {
  private static readonly capabilityRepositoryToken = Symbol(
    "ICapabilityRepository",
  );
  private static readonly capabilityUseCaseToken = Symbol("CapabilityUseCase");
  private static readonly capabilityViewModelToken = Symbol(
    "CapabilityViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.capabilityRepositoryToken,
      useClass: CapabilityImpl,
    },
    {
      scope: "otherRepo",
      token: this.capabilityUseCaseToken,
      useClass: CapabilityUseCase,
    },
    {
      scope: "viewModel",
      token: this.capabilityViewModelToken,
      useClass: CapabilityViewModel,
    },
  ];

  static getRepo(): ICapabilityRepository {
    return this.resolve(this.capabilityRepositoryToken);
  }

  static getUseCase(): CapabilityUseCase {
    return this.resolve(this.capabilityUseCaseToken);
  }
}
